import { render, staticRenderFns } from "./Surveys.vue?vue&type=template&id=286f4842&scoped=true&"
import script from "./Surveys.vue?vue&type=script&lang=js&"
export * from "./Surveys.vue?vue&type=script&lang=js&"
import style0 from "./Surveys.vue?vue&type=style&index=0&id=286f4842&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286f4842",
  null
  
)

export default component.exports